<template>
    <b-modal
        id="ModalCreateCronjob"
        title="Créer une tâche programmée"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        size="xl"
        hide-footer
    >
        <FormCronjob @saved="onSaved" />
    </b-modal>
</template>
<script>
import FormCronjob from "./FormCronjob";
export default {
    components: {
        FormCronjob,
    },

    methods: {
        onSaved() {
            this.$bvModal.hide("ModalCreateCronjob");
            this.$emit("saved");
        },
    },
};
</script>
